import { getFirestore, query, collection, where, getDocs } from "firebase/firestore";
import { app } from "../config";

const db = getFirestore(app);

const getMPSBusinessDetails = async (userId) => {
    try {
        // Reference the MPS_BusinessProfiles collection
        const userQuery = query(
            collection(db, "MPS_BusinessProfiles"),
            where("userId", "==", userId)
        );

        // Execute the query and get the documents
        const querySnapshot = await getDocs(userQuery);

        if (querySnapshot.empty) {
            return { success: false, message: "No business profile found for this userId." };
        }

        // Assuming there's only one document with this userId
        const businessDetails = querySnapshot.docs.map((doc) => {
            return {
                userId: doc.id,
                ...doc.data(),
            };
        });

        return businessDetails[0]

    } catch (error) {
        console.error("Error fetching user details:", error);
        return { success: false, message: `Error: ${error.message}` };
    }
};

export { getMPSBusinessDetails };